import http_request from './http_request'
import config from 'config'
import fileAppendToForm from 'helpers/fileAppendToForm'
import lessonSources from 'helpers/enums/lessonSources'
import agentTypes from 'helpers/enums/agentTypes'
import animationPaths from 'animations/paths'
import lessonTypes from 'helpers/enums/lessonTypes'

function getUserLibrary(
	limit,
	page,
	searchString,
	orderField,
	orderType,
	folderUID,
	fromLTI,
	type = lessonTypes.REGULAR,
	showAllLessons,
) {
	return http_request.post(config.services + 'presentation/search.php')
		.send({
			limit,
			page,
			search: searchString,
			orderField,
			orderType,
			entityUID: folderUID,
			fromLTI,
			type,
			showAllLessons,
		})
}

function getUserLibraryFolders(folderUID = 0, fromLTI) {
	return http_request.post(config.services + 'userCategories/all')
		.send({
			parentId: folderUID,
			fromLTI,
		})
}

function launchMyLibraryHomework(device_type, presentation_uid, device_uid, session_uid, isNew, jwt, lms = '', validateCollaborate = false) {
	const headers = {}
	if (jwt) {
		headers.jwt = jwt
	}

	return http_request.post(config.services + 'service.php')
		.withHeaders(headers)
		.send({
			method: 'shareHomeworkPin',
			device_type,
			presentation_uid,
			device_uid,
			session_uid,
			new: isNew,
			lms,
			validateCollaborate,
		})
}

function launchMyLibraryLiveLesson(device_type, presentation_uid, device_uid, session_uid, isNew, jwt, lms = '') {
	const headers = {}
	if (jwt) {
		headers.jwt = jwt
	}

	return http_request.post(config.hub + 'session/start')
		.withHeaders(headers)
		.send({
			device_type,
			presentation_uid,
			device_uid,
			session_uid,
			new: isNew,
			lms,
		})
}

function myLibrarySharePin(pin, presentation_uid) {
	return http_request.post(config.services + 'service.php')
		.send({
			method: 'sharePin',
			pin,
			presentation_uid,
		})
}

function deleteLesson(entitiesUID) {

	return http_request.post(config.ct + 'service/presentation/delete.php')
		.send({
			entitiesUID,
		})
}

function saveChanges(entityUID) {
	return http_request.post(config.services + 'presentation/publish.php')
		.send ({
			entitiesUID: entityUID,
		})
}

function getLessonsStatus(entities) {
	return http_request.post(config.ct + 'service/presentation/status.php')
		.send ({
			entitiesUID: entities,
		})
}

function addToPublicLibrary(entities) {
	return http_request.post(config.api + 'storefront/me/entities')
		.withJWT()
		.send ({
			lesson_ids: entities,
		})
}

function addLessonsToFolder(presentationUIDs, folderUID) {
	//&presentationUIDs=
	return http_request.post(config.ct + 'service/presentationCategories/save')
		.send ({
			entityUID: folderUID,
			presentationUIDs,
		})
}

function removeLessonsFromFolder(presentationUIDs, entityUID) {
	return http_request.post(config.ct + 'service/presentationCategories/delete')
		.send ({
			entityUID,
			presentationUIDs,
		})
}

function getLessonPdfUrl(entityUID) {
	return http_request.post(config.services + 'presentation/exportPDF.php')
		.send ({
			entityUID,
		})
}

function addOrUpdateFolder(folder, folderName, presentationUID, parentFolder, colorId) {
	const params = {
		name: folderName,
	}
	if (folder) {
		params.entityUID = folder
	}
	if (presentationUID) {
		params.presentationUID = presentationUID
	}
	if (parentFolder) {
		params.parentId = parentFolder
	}
	if (colorId) {
		params.color = colorId
	}
	return http_request.post(config.ct + 'service/userCategories/save')
		.send(params)
}

function removeFolder(entityUID) {
	return http_request.post(config.services + 'userCategories/delete')
		.send ({
			entityUID,
		})
}

function editLesson(entityUID, folderId, unpublish = '') {
	return http_request.post(config.ct + 'service/presentation/copy.php')
		.send ({
			entityUID,
			folderId,
			unpublish,
		})
}

function searchLessonsForPicker(limit, page, search, orderField, orderType, entityUID) {
	return http_request.post(config.ct + 'service/presentation/search.php')
		.send ({
			limit,
			page,
			search,
			orderField,
			orderType,
			searchFromFolder: '1',
			entityUID,
		})
}

function saveExpirationDate(expiration_date, session_uid) {
	return http_request.post(config.hub + 'session/adjust_expiration')
		.withJWT()
		.send ({
			expiration_date,
			session_uid,
		})
}

function shareNPPFolder(entityUID, userId) {
	return http_request.post(config.services + 'service.php')
		.send({
			method: 'shareNPPFolder',
			folderId: entityUID,
			userId,
		})
}

function firstLessonUploadFile(file) {
	let formData = new FormData()
	formData = fileAppendToForm(formData, file)
	return http_request.post(config.api + 'first_lesson/upload')
		.type('')
		.send(formData)
}

function firstLessonPresentationPublish(presentationId) {
	return http_request.post(config.api + 'first_lesson/publish')
		.send({
			presentationId,
		})
}

function firstLessonLoadAsset() {
	return http_request.get(animationPaths.FIRST_LESSON_LOADING)
		.setAgentType(agentTypes.RAW)
		.type(null)
		.withCredentials(false)
		.send()
}

function linkGoogleSlideWithNearpodLesson(googleSlideUid, title = '', slideExternalIds) {
	return http_request.post(config.api + 'presentation/external')
		.send ({
			externalId: googleSlideUid,
			source: 1,
			title,
			slides: slideExternalIds,
		})
}

function saveGoogleSlidesToNearpod(googleSlideUid, slides, title = '') {
	return http_request.put(`${config.api}presentation/external`)
		.send({
			externalId: googleSlideUid,
			source: 1,
			slides,
			title,
		})
}

function startGoogleSlidesSavePresentation(googleSlideUid) {
	return http_request.post(`${config.api}presentation/external/save/start`)
		.send({
			externalId: googleSlideUid,
			source: lessonSources.GOOGLE_SLIDES,
		})
}

function processSaveGoogleSlidesSlides(googleSlideUid, slides) {
	return http_request.post(`${config.api}presentation/external/save/process_slides`)
		.send({
			externalId: googleSlideUid,
			source: lessonSources.GOOGLE_SLIDES,
			slides,
		})
}

function endGoogleSlidesSavePresentation(googleSlideUid, slideIds, title = '', presentationMetadata = '') {
	return http_request.post(`${config.api}presentation/external/save/end`)
		.send({
			externalId: googleSlideUid,
			source: lessonSources.GOOGLE_SLIDES,
			slideIds,
			title,
			presentationMetadata,
		})
}

function cancelGoogleSlidesSavePresentation(googleSlideUid) {
	return http_request.post(`${config.api}presentation/external/save/cancel`)
		.send({
			externalId: googleSlideUid,
			source: lessonSources.GOOGLE_SLIDES,
		})
}

function getGoogleSlideTypes(payload) {
	return http_request.get(`${config.api}slide/external/list`)
		.send(payload)
}

function convertToDrawIt(externalId, thumbnail) {
	return http_request.post(`${config.api}slide/external/convert_to_draw_it`)
		.send({
			source: lessonSources.GOOGLE_SLIDES,
			presentationExternalId: externalId,
			thumbnailUrl: thumbnail,
		})
}

// code repeated on private_library_sync and store_sync
function launchSession(presentation_uid, isNew, jwt, sessionType) {
	const headers = {}
	if (jwt) {
		headers.jwt = jwt
	}

	return http_request.post(config.hub + 'session/start')
		.withHeaders(headers)
		.send({
			device_type: 'ipad',
			presentation_uid,
			device_uid: 'tabc',
			session_uid: '',
			new: isNew,
			session_type: sessionType,
		})
}

function saveSessionSubmissionRequired(value, sessionUid, jwt) {
	const headers = {}
	if (jwt) {
		headers.jwt = jwt
	}

	return http_request.put(`${config.api_hub}teacher/sessions/${sessionUid}`)
		.withHeaders(headers)
		.send({
			is_submission_required: value,
		})
}

function editUnpublishedVideoLesson(entityUID) {
	return http_request.put(`${config.api}interactive_video`)
		.send ({entityUID})
}

function getActivePincodes(presentation_uid, jwt) {
	const headers = {}
	if (jwt) {
		headers.jwt = jwt
	}

	return http_request.get(
		`${config.api_hub}teacher/presentation/${presentation_uid}/active_pincodes`
	).withHeaders(headers).send()
}


export default {
	getUserLibrary,
	getUserLibraryFolders,
	launchMyLibraryHomework,
	launchMyLibraryLiveLesson,
	myLibrarySharePin,
	deleteLesson,
	saveChanges,
	getLessonsStatus,
	addToPublicLibrary,
	addLessonsToFolder,
	removeLessonsFromFolder,
	removeFolder,
	getLessonPdfUrl,
	addOrUpdateFolder,
	editLesson,
	searchLessonsForPicker,
	saveExpirationDate,
	shareNPPFolder,
	firstLessonUploadFile,
	firstLessonPresentationPublish,
	firstLessonLoadAsset,
	linkGoogleSlideWithNearpodLesson,
	saveGoogleSlidesToNearpod,
	startGoogleSlidesSavePresentation,
	processSaveGoogleSlidesSlides,
	endGoogleSlidesSavePresentation,
	cancelGoogleSlidesSavePresentation,
	getGoogleSlideTypes,
	convertToDrawIt,
	launchSession,
	saveSessionSubmissionRequired,
	editUnpublishedVideoLesson,
	getActivePincodes,
}
